const jhscoreScienceQuestions = [
  {
    question: "What is the main source of energy for life on Earth?",
    options: ["Wind", "Sun", "Water", "Electricity"],
    answer: "Sun"
  },
  {
    question: "A plant is kept in a dark room for several days. What is most likely to happen?",
    options: ["It will grow faster", "It will stop photosynthesis and weaken", "It will produce more oxygen", "It will store more food"],
    answer: "It will stop photosynthesis and weaken"
  },
  {
    question: "Which condition is necessary for rusting of iron to occur?",
    options: ["Heat only", "Water and oxygen", "Carbon dioxide only", "Sunlight only"],
    answer: "Water and oxygen"
  },
  {
    question: "What will happen if the stomata of a plant are completely closed?",
    options: ["Photosynthesis increases", "Gas exchange stops", "Water absorption increases", "Root growth stops"],
    answer: "Gas exchange stops"
  },
  {
    question: "Why are metals like copper used for electrical wiring?",
    options: ["They are soft", "They are good conductors", "They are cheap", "They are light"],
    answer: "They are good conductors"
  },
  {
    question: "What is the effect of a lack of protein in a child's diet?",
    options: ["Faster growth", "Strong bones", "Poor growth and body repair", "Increased energy"],
    answer: "Poor growth and body repair"
  },
  {
    question: "Which of the following best explains why oil floats on water?",
    options: ["Oil is heavier", "Oil is less dense than water", "Oil is soluble in water", "Oil evaporates quickly"],
    answer: "Oil is less dense than water"
  },
  {
    question: "What happens when a current flows through a conductor?",
    options: ["It produces heat", "It stops movement", "It destroys the conductor", "It removes energy"],
    answer: "It produces heat"
  },
  {
    question: "Which process removes excess water from plant leaves?",
    options: ["Photosynthesis", "Respiration", "Transpiration", "Absorption"],
    answer: "Transpiration"
  },
  {
    question: "A student mixes sand and salt in water. Which method will separate both substances completely?",
    options: ["Filtration only", "Evaporation only", "Filtration and evaporation", "Decanting only"],
    answer: "Filtration and evaporation"
  },
  {
    question: "What will happen if white blood cells are low in the body?",
    options: ["More oxygen is carried", "Blood clots faster", "Body becomes weak against infections", "Digestion improves"],
    answer: "Body becomes weak against infections"
  },
  {
    question: "Which of the following best describes energy?",
    options: ["Ability to sleep", "Ability to do work", "Ability to grow", "Ability to move only"],
    answer: "Ability to do work"
  },
  {
    question: "Why is the small intestine important in digestion?",
    options: ["It stores food", "It breaks large food only", "It absorbs digested nutrients", "It removes waste"],
    answer: "It absorbs digested nutrients"
  },
  {
    question: "Which change is irreversible?",
    options: ["Melting ice", "Freezing water", "Burning paper", "Boiling water"],
    answer: "Burning paper"
  },
  {
    question: "What is the role of chlorophyll in plants?",
    options: ["Absorbs water", "Traps sunlight", "Stores food", "Produces roots"],
    answer: "Traps sunlight"
  },
  {
    question: "Which human activity increases carbon dioxide in the atmosphere?",
    options: ["Planting trees", "Burning fuels", "Watering crops", "Recycling waste"],
    answer: "Burning fuels"
  },
  {
    question: "What happens when light enters a different medium like water?",
    options: ["It disappears", "It bends", "It stops", "It increases speed"],
    answer: "It bends"
  },
  {
    question: "Which of the following helps to prevent soil erosion?",
    options: ["Cutting trees", "Overgrazing", "Planting vegetation", "Burning bush"],
    answer: "Planting vegetation"
  },
  {
    question: "Why is the skeleton important in the human body?",
    options: ["It produces energy", "It supports and protects organs", "It digests food", "It controls breathing"],
    answer: "It supports and protects organs"
  },
  {
    question: "What is likely to happen if there is no gravity on Earth?",
    options: ["Objects will fall faster", "Objects will float", "Objects will become heavier", "Objects will stop moving"],
    answer: "Objects will float"
  },
  {
    question: "Which of the following best explains a renewable resource?",
    options: ["It cannot be replaced", "It is used once", "It can be replaced naturally", "It is very expensive"],
    answer: "It can be replaced naturally"
  },
  {
    question: "A plant is watered regularly but kept in darkness. Which factor is missing for food production?",
    options: ["Water", "Carbon dioxide", "Light", "Oxygen"],
    answer: "Light"
  },
  {
    question: "During an experiment, a student heats a solid until it melts. What type of change is this?",
    options: ["Chemical change", "Irreversible change", "Physical change", "Biological change"],
    answer: "Physical change"
  },
  {
    question: "Why does a person breathe faster after running?",
    options: ["To cool the body", "To supply more oxygen to cells", "To remove water", "To increase blood pressure"],
    answer: "To supply more oxygen to cells"
  },
  {
    question: "Which organ is responsible for filtering waste from the blood?",
    options: ["Heart", "Kidney", "Lungs", "Liver"],
    answer: "Kidney"
  },
  {
    question: "A student connects a circuit but the bulb does not light. What is the most likely reason?",
    options: ["The wire is too long", "The circuit is incomplete", "The battery is too strong", "The bulb is too big"],
    answer: "The circuit is incomplete"
  },
  {
    question: "Why is it important to boil water before drinking in some areas?",
    options: ["To improve taste", "To kill harmful microorganisms", "To change colour", "To remove oxygen"],
    answer: "To kill harmful microorganisms"
  },
  {
    question: "Which gas is mainly responsible for global warming?",
    options: ["Oxygen", "Nitrogen", "Carbon dioxide", "Hydrogen"],
    answer: "Carbon dioxide"
  },
  {
    question: "What happens to particles in a gas when heated?",
    options: ["They stop moving", "They move faster", "They become smaller", "They disappear"],
    answer: "They move faster"
  },
  {
    question: "Which part of the eye controls the amount of light entering?",
    options: ["Lens", "Retina", "Pupil", "Optic nerve"],
    answer: "Pupil"
  },
  {
    question: "Why do objects fall to the ground when dropped?",
    options: ["Air pressure", "Magnetism", "Gravity", "Friction"],
    answer: "Gravity"
  },
  {
    question: "Which method is best for separating oil from water?",
    options: ["Filtration", "Evaporation", "Decanting", "Sieving"],
    answer: "Decanting"
  },
  {
    question: "What is the main function of red blood cells?",
    options: ["Fight infection", "Transport oxygen", "Clot blood", "Digest food"],
    answer: "Transport oxygen"
  },
  {
    question: "Which form of energy is stored in food?",
    options: ["Light energy", "Chemical energy", "Electrical energy", "Sound energy"],
    answer: "Chemical energy"
  },
  {
    question: "What is the effect of cutting down too many trees?",
    options: ["More oxygen", "Increased rainfall", "Soil erosion", "Better air quality"],
    answer: "Soil erosion"
  },
  {
    question: "Why does salt dissolve faster in warm water than in cold water?",
    options: ["Particles move slower", "Particles move faster", "Water becomes heavier", "Salt becomes lighter"],
    answer: "Particles move faster"
  },
  {
    question: "Which of the following is a good conductor of heat?",
    options: ["Wood", "Plastic", "Metal", "Rubber"],
    answer: "Metal"
  },
  {
    question: "What will happen if a plant does not get enough water?",
    options: ["It will grow faster", "It will wilt", "It will produce more leaves", "It will become stronger"],
    answer: "It will wilt"
  },
  {
    question: "Which type of energy is produced by vibrating objects?",
    options: ["Light energy", "Heat energy", "Sound energy", "Chemical energy"],
    answer: "Sound energy"
  },
  {
    question: "Why is the ozone layer important?",
    options: ["It produces oxygen", "It absorbs harmful ultraviolet radiation", "It controls rainfall", "It forms clouds"],
    answer: "It absorbs harmful ultraviolet radiation"
  },
  {
    question: "What happens when a magnet is cut into two pieces?",
    options: ["Only one remains magnetic", "Both pieces become magnets", "Magnetism disappears", "They repel each other"],
    answer: "Both pieces become magnets"
  },
  {
    question: "A plant is exposed to sunlight but has no carbon dioxide. What will happen?",
    options: ["Photosynthesis will continue", "Photosynthesis will stop", "Respiration will stop", "Growth will increase"],
    answer: "Photosynthesis will stop"
  },
  {
    question: "Why does sweating help to cool the body?",
    options: ["It increases body temperature", "It removes oxygen", "Evaporation takes away heat", "It adds water to the body"],
    answer: "Evaporation takes away heat"
  },
  {
    question: "Which condition will increase the rate of dissolving sugar in water?",
    options: ["Cold water and no stirring", "Warm water and stirring", "Cold water and no movement", "Large sugar pieces only"],
    answer: "Warm water and stirring"
  },
  {
    question: "What happens to sound as it travels through air?",
    options: ["It disappears immediately", "It spreads out and becomes weaker", "It becomes stronger always", "It stops suddenly"],
    answer: "It spreads out and becomes weaker"
  },
  {
    question: "A student breathes out into limewater and it turns milky. What does this show?",
    options: ["Oxygen is present", "Carbon dioxide is present", "Nitrogen is present", "Hydrogen is present"],
    answer: "Carbon dioxide is present"
  },
  {
    question: "Why do farmers add fertilizers to soil?",
    options: ["To increase soil temperature", "To add nutrients for plant growth", "To reduce sunlight", "To remove water"],
    answer: "To add nutrients for plant growth"
  },
  {
    question: "What happens when electrical appliances are connected in series?",
    options: ["All work independently", "If one fails", "all stop working", "Voltage increases in each", "Current increases automatically"],
    answer: "If one fails, all stop working"
  },
  {
    question: "Which of the following best explains friction?",
    options: ["Force that pushes objects apart", "Force that opposes motion", "Force that creates energy", "Force that attracts objects"],
    answer: "Force that opposes motion"
  },
  {
    question: "What is the main reason for deforestation?",
    options: ["Planting trees", "Urbanization and farming", "Reducing pollution", "Protecting wildlife"],
    answer: "Urbanization and farming"
  },
  {
    question: "Which part of a plant transports water from roots to leaves?",
    options: ["Phloem", "Xylem", "Stomata", "Chloroplast"],
    answer: "Xylem"
  },
  {
    question: "Why do solids have fixed shapes?",
    options: ["Particles move freely", "Particles are closely packed", "Particles are far apart", "Particles disappear"],
    answer: "Particles are closely packed"
  },
  {
    question: "What happens when light hits a mirror?",
    options: ["It is absorbed", "It is reflected", "It is destroyed", "It stops moving"],
    answer: "It is reflected"
  },
  {
    question: "Which system of the body is responsible for movement?",
    options: ["Digestive system", "Respiratory system", "Muscular system", "Circulatory system"],
    answer: "Muscular system"
  },
  {
    question: "What will happen if the temperature of a liquid is lowered?",
    options: ["Particles move faster", "Particles slow down", "Particles disappear", "Particles expand"],
    answer: "Particles slow down"
  },
  {
    question: "Why is clean air important for humans?",
    options: ["It increases pollution", "It supports healthy breathing", "It reduces sunlight", "It produces food"],
    answer: "It supports healthy breathing"
  },
  {
    question: "Which of the following is an example of a chemical change?",
    options: ["Melting wax", "Cutting paper", "Cooking food", "Freezing water"],
    answer: "Cooking food"
  },
  {
    question: "What is the main function of the lungs?",
    options: ["Pump blood", "Exchange gases", "Digest food", "Control movement"],
    answer: "Exchange gases"
  },
  {
    question: "Why do objects appear bent in water?",
    options: ["Reflection", "Refraction", "Diffusion", "Gravity"],
    answer: "Refraction"
  },
  {
    question: "Which type of energy is used in a battery?",
    options: ["Mechanical energy", "Chemical energy", "Sound energy", "Light energy"],
    answer: "Chemical energy"
  },
  {
    question: "What happens when waste is not properly managed?",
    options: ["Environment improves", "Pollution increases", "Air becomes cleaner", "Water becomes pure"],
    answer: "Pollution increases"
  },
  {
    question: "A student places a green plant in sunlight and covers part of a leaf. After testing with iodine, only uncovered parts turn blue-black. What does this show?",
    options: ["Water is needed for photosynthesis", "Light is required for photosynthesis", "Oxygen is required", "Chlorophyll is absent"],
    answer: "Light is required for photosynthesis"
  },
  {
    question: "Why do we see lightning before hearing thunder?",
    options: ["Light travels faster than sound", "Sound travels faster than light", "Lightning is stronger", "Thunder is weaker"],
    answer: "Light travels faster than sound"
  },
  {
    question: "Which of the following explains why cutting trees affects rainfall?",
    options: ["Trees reduce sunlight", "Trees help in water cycle through transpiration", "Trees produce heat", "Trees absorb oxygen"],
    answer: "Trees help in water cycle through transpiration"
  },
  {
    question: "A bulb glows dimly in a circuit. What could be the reason?",
    options: ["High voltage", "Weak battery or resistance", "Too much light", "Short circuit"],
    answer: "Weak battery or resistance"
  },
  {
    question: "Why does food spoil faster in warm conditions?",
    options: ["Less oxygen", "Microorganisms grow faster", "Food loses water", "Less sunlight"],
    answer: "Microorganisms grow faster"
  },
  {
    question: "What will happen if there is no chlorophyll in a plant?",
    options: ["It will photosynthesize normally", "It cannot make food", "It will grow faster", "It will produce more oxygen"],
    answer: "It cannot make food"
  },
  {
    question: "Why are mirrors used in periscopes?",
    options: ["To absorb light", "To reflect light", "To bend light", "To block light"],
    answer: "To reflect light"
  },
  {
    question: "Which of the following explains why metals expand when heated?",
    options: ["Particles move closer", "Particles gain energy and move apart", "Particles stop moving", "Particles disappear"],
    answer: "Particles gain energy and move apart"
  },
  {
    question: "A person with damaged alveoli will have difficulty in:",
    options: ["Digesting food", "Exchanging gases", "Pumping blood", "Producing hormones"],
    answer: "Exchanging gases"
  },
  {
    question: "Why is it dangerous to overload electrical sockets?",
    options: ["It reduces current", "It causes overheating and fire", "It increases light", "It improves efficiency"],
    answer: "It causes overheating and fire"
  },
  {
    question: "Which of the following best explains evaporation?",
    options: ["Liquid changes to solid", "Liquid changes to gas at the surface", "Gas changes to liquid", "Solid changes to liquid"],
    answer: "Liquid changes to gas at the surface"
  },
  {
    question: "Why do plants wilt when not watered?",
    options: ["Loss of chlorophyll", "Loss of turgidity in cells", "Increase in oxygen", "Decrease in sunlight"],
    answer: "Loss of turgidity in cells"
  },
  {
    question: "Which of the following is an effect of air pollution?",
    options: ["Improved health", "Acid rain", "Better crops", "Clean air"],
    answer: "Acid rain"
  },
  {
    question: "Why do objects appear smaller when viewed from far away?",
    options: ["Light bends", "Less light enters the eye", "Image size on retina reduces", "Objects shrink"],
    answer: "Image size on retina reduces"
  },
  {
    question: "Which part of the digestive system produces bile?",
    options: ["Stomach", "Liver", "Pancreas", "Small intestine"],
    answer: "Liver"
  },
  {
    question: "What happens to current in a parallel circuit?",
    options: ["It is the same everywhere", "It divides among branches", "It disappears", "It becomes zero"],
    answer: "It divides among branches"
  },
  {
    question: "Why is water important in the human body?",
    options: ["Only for drinking", "For transport of substances and temperature control", "To produce bones", "To create oxygen"],
    answer: "For transport of substances and temperature control"
  },
  {
    question: "Which of the following shows conservation of energy?",
    options: ["Energy is destroyed", "Energy changes form but is not lost", "Energy disappears", "Energy is reduced completely"],
    answer: "Energy changes form but is not lost"
  },
  {
    question: "What will happen if soil lacks nutrients?",
    options: ["Plants grow well", "Plants grow poorly", "Plants grow faster", "Plants produce more seeds"],
    answer: "Plants grow poorly"
  },
  {
    question: "Why is proper waste disposal important?",
    options: ["To increase pollution", "To protect environment and health", "To reduce oxygen", "To increase heat"],
    answer: "To protect environment and health"
  },
  {
    question: "A plant is kept in sunlight but its leaves are covered with grease. What will happen?",
    options: ["Photosynthesis increases", "Gas exchange is prevented", "Water absorption increases", "Root growth stops"],
    answer: "Gas exchange is prevented"
  },
  {
    question: "Why does ice float on water?",
    options: ["Ice is heavier", "Ice is less dense than water", "Ice contains air only", "Ice has no mass"],
    answer: "Ice is less dense than water"
  },
  {
    question: "Which situation best demonstrates convection?",
    options: ["Heating a metal rod", "Warm air rising above a fire", "Light reflecting in a mirror", "Sound traveling in air"],
    answer: "Warm air rising above a fire"
  },
  {
    question: "What will happen if a personâ€™s pancreas stops producing insulin?",
    options: ["Digestion stops", "Blood sugar becomes uncontrolled", "Breathing becomes faster", "Blood pressure decreases"],
    answer: "Blood sugar becomes uncontrolled"
  },
  {
    question: "Why does a closed container of gas increase in pressure when heated?",
    options: ["Particles slow down", "Particles collide more frequently", "Gas disappears", "Volume increases"],
    answer: "Particles collide more frequently"
  },
  {
    question: "Which of the following is a non-renewable source of energy?",
    options: ["Solar energy", "Wind energy", "Coal", "Hydro energy"],
    answer: "Coal"
  },
  {
    question: "What is the main reason for food preservation?",
    options: ["To increase taste", "To slow down microbial growth", "To change colour", "To increase water content"],
    answer: "To slow down microbial growth"
  },
  {
    question: "Why does a shadow change size during the day?",
    options: ["Light disappears", "Position of the Sun changes", "Objects shrink", "Air pressure changes"],
    answer: "Position of the Sun changes"
  },
  {
    question: "Which part of the plant carries manufactured food?",
    options: ["Xylem", "Phloem", "Root hairs", "Stomata"],
    answer: "Phloem"
  },
  {
    question: "What is the effect of too much fertilizer on crops?",
    options: ["Improves growth always", "Can damage plants", "Increases water only", "No effect"],
    answer: "Can damage plants"
  },
  {
    question: "Why does sound not travel in a vacuum?",
    options: ["No energy is present", "No medium for vibration", "No light is present", "No pressure exists"],
    answer: "No medium for vibration"
  },
  {
    question: "What happens when two like poles of magnets are brought together?",
    options: ["They attract", "They repel", "They disappear", "They combine"],
    answer: "They repel"
  },
  {
    question: "Which process in plants releases oxygen?",
    options: ["Respiration", "Photosynthesis", "Transpiration", "Absorption"],
    answer: "Photosynthesis"
  },
  {
    question: "Why is it important to wash hands before eating?",
    options: ["To remove water", "To kill harmful microorganisms", "To improve digestion", "To increase appetite"],
    answer: "To kill harmful microorganisms"
  },
  {
    question: "What is the main function of the brain?",
    options: ["Pumping blood", "Controlling body activities", "Digesting food", "Producing energy"],
    answer: "Controlling body activities"
  },
  {
    question: "Which of the following best explains condensation?",
    options: ["Gas to liquid", "Liquid to gas", "Solid to liquid", "Solid to gas"],
    answer: "Gas to liquid"
  },
  {
    question: "Why do we see different colours in a rainbow?",
    options: ["Reflection only", "Refraction and dispersion of light", "Absorption of light", "Sound waves"],
    answer: "Refraction and dispersion of light"
  },
  {
    question: "What will happen if plants are removed from an ecosystem?",
    options: ["Animals survive easily", "Food chain is disrupted", "Water increases", "Soil becomes richer"],
    answer: "Food chain is disrupted"
  },
  {
    question: "Which of the following is an example of renewable energy?",
    options: ["Petrol", "Coal", "Wind", "Diesel"],
    answer: "Wind"
  },
  {
    question: "Why is iron often coated with paint?",
    options: ["To make it heavier", "To prevent rusting", "To increase strength", "To reduce weight"],
    answer: "To prevent rusting"
  },
  {
    question: "A student places a plant in a sealed container with no fresh air. What is most likely to happen after some time?",
    options: ["Photosynthesis increases", "Plant dies due to lack of carbon dioxide and oxygen balance", "Plant grows faster", "Nothing happens"],
    answer: "Plant dies due to lack of carbon dioxide and oxygen balance"
  },
  {
    question: "Which of the following explains why metals feel cold when touched?",
    options: ["They produce cold", "They conduct heat away from the body quickly", "They absorb light", "They have no energy"],
    answer: "They conduct heat away from the body quickly"
  },
  {
    question: "Why is blood circulation important in the human body?",
    options: ["It produces food", "It transports oxygen and nutrients", "It controls movement", "It removes bones"],
    answer: "It transports oxygen and nutrients"
  },
  {
    question: "What will happen if a circuit has very high resistance?",
    options: ["Current increases", "Current decreases", "Voltage disappears", "Energy increases"],
    answer: "Current decreases"
  },
  {
    question: "Which of the following is an example of kinetic energy?",
    options: ["Stored food energy", "Moving car", "Battery energy", "Chemical energy"],
    answer: "Moving car"
  },
  {
    question: "Why does a balloon expand when heated?",
    options: ["Air disappears", "Particles move faster and spread out", "Pressure decreases", "Temperature reduces"],
    answer: "Particles move faster and spread out"
  },
  {
    question: "What is the effect of water pollution on aquatic life?",
    options: ["Improves survival", "Reduces oxygen availability", "Increases food supply", "Improves growth"],
    answer: "Reduces oxygen availability"
  },
  {
    question: "Which part of the ear is responsible for detecting sound vibrations?",
    options: ["Eardrum", "Pupil", "Nose", "Tongue"],
    answer: "Eardrum"
  },
  {
    question: "Why does sugar dissolve faster when crushed into smaller pieces?",
    options: ["Less surface area", "Greater surface area", "Less energy", "Less contact with water"],
    answer: "Greater surface area"
  },
  {
    question: "What happens when light passes through a glass prism?",
    options: ["It disappears", "It splits into colours", "It stops moving", "It becomes sound"],
    answer: "It splits into colours"
  },
  {
    question: "Which of the following is an effect of poor sanitation?",
    options: ["Improved health", "Spread of diseases", "Better environment", "Increased oxygen"],
    answer: "Spread of diseases"
  },
  {
    question: "Why is the heart described as a double pump?",
    options: ["It pumps blood once", "It pumps blood to lungs and body separately", "It pumps water", "It produces energy"],
    answer: "It pumps blood to lungs and body separately"
  },
  {
    question: "What will happen if friction is completely removed?",
    options: ["Objects stop moving", "Movement becomes uncontrollable", "Energy disappears", "Heat increases"],
    answer: "Movement becomes uncontrollable"
  },
  {
    question: "Which of the following is a chemical property of a substance?",
    options: ["Colour", "Density", "Reactivity", "Shape"],
    answer: "Reactivity"
  },
  {
    question: "Why is sunlight important for the Earth?",
    options: ["It produces water", "It is a main source of energy", "It reduces oxygen", "It destroys plants"],
    answer: "It is a main source of energy"
  },
  {
    question: "Which of the following helps in digestion of fats?",
    options: ["Saliva", "Bile", "Oxygen", "Blood"],
    answer: "Bile"
  },
  {
    question: "What happens when a liquid cools down?",
    options: ["Particles move faster", "Particles lose energy and slow down", "Particles disappear", "Particles expand"],
    answer: "Particles lose energy and slow down"
  },
  {
    question: "Why is recycling important?",
    options: ["To increase waste", "To reduce environmental pollution", "To reduce oxygen", "To increase heat"],
    answer: "To reduce environmental pollution"
  },
  {
    question: "Which type of force pulls objects toward the Earth?",
    options: ["Magnetic force", "Gravitational force", "Frictional force", "Electrical force"],
    answer: "Gravitational force"
  },
  {
    question: "What will happen if the ozone layer is damaged?",
    options: ["More harmful radiation reaches Earth", "Less sunlight reaches Earth", "Air becomes cleaner", "Rainfall increases"],
    answer: "More harmful radiation reaches Earth"
  },
  {
    question: "Which organ pumps blood throughout the human body?",
    options: ["Lungs", "Heart", "Kidney", "Liver"],
    answer: "Heart"
  },
  {
    question: "What is the main function of the lungs in the human body?",
    options: ["Pump blood", "Exchange gases (oxygen and carbon dioxide)", "Digest food", "Store nutrients"],
    answer: "Exchange gases (oxygen and carbon dioxide)"
  },
  {
    question: "Which part of the plant carries water from the roots to the leaves?",
    options: ["Phloem", "Xylem", "Stomata", "Chlorophyll"],
    answer: "Xylem"
  },
  {
    question: "Which gas do plants take in during photosynthesis?",
    options: ["Oxygen", "Nitrogen", "Carbon dioxide", "Hydrogen"],
    answer: "Carbon dioxide"
  },
  {
    question: "Which gas is released during photosynthesis?",
    options: ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
    answer: "Oxygen"
  },
  {
    question: "What is the main function of the roots of a plant?",
    options: ["Make food", "Absorb water and anchor the plant", "Produce flowers", "Release oxygen"],
    answer: "Absorb water and anchor the plant"
  },
  {
    question: "Which force pulls objects toward the Earth?",
    options: ["Magnetic force", "Frictional force", "Gravitational force", "Electrical force"],
    answer: "Gravitational force"
  },
  {
    question: "Which state of matter has a definite shape and volume?",
    options: ["Solid", "Liquid", "Gas", "Plasma"],
    answer: "Solid"
  },
  {
    question: "Which state of matter takes the shape of its container but has fixed volume?",
    options: ["Solid", "Liquid", "Gas", "Plasma"],
    answer: "Liquid"
  },
  {
    question: "Which method is used to separate an insoluble solid from a liquid?",
    options: ["Evaporation", "Filtration", "Distillation", "Sieving"],
    answer: "Filtration"
  },
  {
    question: "What type of change occurs when paper is burned?",
    options: ["Physical change", "Reversible change", "Chemical change", "Temporary change"],
    answer: "Chemical change"
  },
  {
    question: "Which organ helps in removing waste from the blood?",
    options: ["Heart", "Lungs", "Kidney", "Brain"],
    answer: "Kidney"
  },
  {
    question: "Which part of the human body controls all activities?",
    options: ["Heart", "Brain", "Liver", "Stomach"],
    answer: "Brain"
  },
  {
    question: "Which type of energy is produced by the Sun?",
    options: ["Sound energy", "Chemical energy", "Light energy", "Electrical energy"],
    answer: "Light energy"
  },
  {
    question: "Which material is a good conductor of electricity?",
    options: ["Plastic", "Rubber", "Copper", "Wood"],
    answer: "Copper"
  },
  {
    question: "Which gas is mainly responsible for breathing in humans?",
    options: ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
    answer: "Oxygen"
  },
  {
    question: "Which part of the digestive system absorbs digested food?",
    options: ["Stomach", "Large intestine", "Small intestine", "Esophagus"],
    answer: "Small intestine"
  },
  {
    question: "Which environmental problem is caused by improper waste disposal?",
    options: ["Clean air", "Pollution", "Better soil", "More oxygen"],
    answer: "Pollution"
  },
  {
    question: "Which natural resource can be replaced over time?",
    options: ["Coal", "Petrol", "Wind", "Natural gas"],
    answer: "Wind"
  },
  {
    question: "What is the function of red blood cells in the body?",
    options: ["Fight infection", "Transport oxygen", "Clot blood", "Digest food"],
    answer: "Transport oxygen"
  },
  {
    question: "Which part of the plant is responsible for making food?",
    options: ["Root", "Stem", "Leaf", "Flower"],
    answer: "Leaf"
  },
  {
    question: "What is the main function of the skeleton?",
    options: ["Produce energy", "Support and protect the body", "Digest food", "Pump blood"],
    answer: "Support and protect the body"
  },
  {
    question: "What happens to water when it is heated to boiling point?",
    options: ["It becomes solid", "It becomes gas", "It disappears", "It becomes heavier"],
    answer: "It becomes gas"
  },
  {
    question: "Which of the following is an example of a physical change?",
    options: ["Burning wood", "Cooking food", "Melting ice", "Rusting iron"],
    answer: "Melting ice"
  },
  {
    question: "Which part of the eye forms the image of an object?",
    options: ["Pupil", "Retina", "Lens", "Cornea"],
    answer: "Retina"
  },
  {
    question: "Which organ produces bile in the human body?",
    options: ["Stomach", "Pancreas", "Liver", "Kidney"],
    answer: "Liver"
  },
  {
    question: "Which type of circuit has more than one path for current?",
    options: ["Series circuit", "Parallel circuit", "Open circuit", "Closed circuit"],
    answer: "Parallel circuit"
  },
  {
    question: "What is the main source of energy for the Earth?",
    options: ["Moon", "Sun", "Wind", "Water"],
    answer: "Sun"
  },
  {
    question: "Which of the following is a non-renewable resource?",
    options: ["Wind", "Solar", "Coal", "Water"],
    answer: "Coal"
  },
  {
    question: "Which part of the body helps in movement by contracting and relaxing?",
    options: ["Bones", "Muscles", "Nerves", "Blood"],
    answer: "Muscles"
  },
  {
    question: "Which gas is used by living organisms for respiration?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
    answer: "Oxygen"
  },
  {
    question: "What happens when light hits a smooth surface like a mirror?",
    options: ["It is absorbed", "It is reflected", "It disappears", "It slows down"],
    answer: "It is reflected"
  },
  {
    question: "Which method is used to separate dissolved salt from water?",
    options: ["Filtration", "Sieving", "Evaporation", "Decanting"],
    answer: "Evaporation"
  },
  {
    question: "Which organ is responsible for pumping blood to all parts of the body?",
    options: ["Liver", "Heart", "Kidney", "Brain"],
    answer: "Heart"
  },
  {
    question: "What is the main cause of air pollution?",
    options: ["Planting trees", "Burning fuels", "Watering crops", "Recycling waste"],
    answer: "Burning fuels"
  },
  {
    question: "Which part of the plant allows gases to enter and leave?",
    options: ["Root hairs", "Stomata", "Xylem", "Phloem"],
    answer: "Stomata"
  },
  {
    question: "Which form of energy is used in a battery?",
    options: ["Mechanical energy", "Chemical energy", "Sound energy", "Light energy"],
    answer: "Chemical energy"
  },
  {
    question: "Which of the following best describes a mixture?",
    options: ["A pure substance", "Two or more substances physically combined", "A chemical compound", "A solid only"],
    answer: "Two or more substances physically combined"
  },
  {
    question: "Why do plants need sunlight?",
    options: ["To absorb water", "To make food through photosynthesis", "To grow roots", "To release oxygen only"],
    answer: "To make food through photosynthesis"
  },
  {
    question: "What will happen if a person does not get enough oxygen?",
    options: ["Energy production decreases", "Digestion increases", "Blood becomes thicker", "Body temperature increases"],
    answer: "Energy production decreases"
  },
  {
    question: "Why do metals conduct electricity better than non-metals?",
    options: ["They are heavier", "They contain free-moving electrons", "They are shiny", "They are harder"],
    answer: "They contain free-moving electrons"
  },
  {
    question: "What is the effect of heating a solid?",
    options: ["Particles stop moving", "Particles gain energy and vibrate faster", "Particles disappear", "Particles shrink"],
    answer: "Particles gain energy and vibrate faster"
  },
  {
    question: "Why is clean water important for human health?",
    options: ["It increases taste", "It prevents diseases", "It produces oxygen", "It improves soil"],
    answer: "It prevents diseases"
  },
  {
    question: "Which organ helps in balancing the body?",
    options: ["Ear", "Eye", "Heart", "Kidney"],
    answer: "Ear"
  },
  {
    question: "Why do we need food in the body?",
    options: ["For colour", "For energy", "growth", "and repair", "For breathing", "For movement only"],
    answer: "For energy, growth, and repair"
  },
  {
    question: "What will happen if plants are deprived of water?",
    options: ["They grow faster", "They wilt and may die", "They produce more oxygen", "They increase in size"],
    answer: "They wilt and may die"
  },
  {
    question: "Why is it easier to push an object on a smooth surface?",
    options: ["More friction", "Less friction", "More weight", "Less energy"],
    answer: "Less friction"
  },
  {
    question: "What is the main function of the large intestine?",
    options: ["Digest proteins", "Absorb water from waste", "Produce enzymes", "Break food"],
    answer: "Absorb water from waste"
  },
  {
    question: "Which part of the plant supports it and transports substances?",
    options: ["Leaf", "Root", "Stem", "Flower"],
    answer: "Stem"
  },
  {
    question: "Why do we use insulators in electrical wiring?",
    options: ["To conduct electricity", "To prevent electric shock", "To increase current", "To produce energy"],
    answer: "To prevent electric shock"
  },
  {
    question: "What happens when a liquid is cooled?",
    options: ["Particles move faster", "Particles lose energy", "Particles disappear", "Particles expand"],
    answer: "Particles lose energy"
  },
  {
    question: "Why are plants important in the ecosystem?",
    options: ["They produce noise", "They provide oxygen and food", "They reduce soil", "They remove sunlight"],
    answer: "They provide oxygen and food"
  },
  {
    question: "Which of the following is an example of friction?",
    options: ["A ball rolling and slowing down", "A stone falling", "Light reflecting", "Water boiling"],
    answer: "A ball rolling and slowing down"
  },
  {
    question: "Why does oil not mix with water?",
    options: ["Oil is heavier", "Oil is insoluble in water", "Oil evaporates", "Oil is solid"],
    answer: "Oil is insoluble in water"
  },
  {
    question: "What happens when food is not properly digested?",
    options: ["Energy increases", "Nutrients are not absorbed well", "Blood increases", "Breathing improves"],
    answer: "Nutrients are not absorbed well"
  },
  {
    question: "Why is the sun important for drying clothes?",
    options: ["It increases water", "It provides heat for evaporation", "It produces air", "It adds weight"],
    answer: "It provides heat for evaporation"
  },
  {
    question: "Which of the following best explains pollution?",
    options: ["Clean environment", "Addition of harmful substances to environment", "Increase in oxygen", "Decrease in water"],
    answer: "Addition of harmful substances to environment"
  },
  {
    question: "Why do we need to conserve natural resources?",
    options: ["To waste them", "To ensure future availability", "To increase pollution", "To reduce oxygen"],
    answer: "To ensure future availability"
  },
  {
    question: "What will happen if stomata in plant leaves remain closed for a long time?",
    options: ["Photosynthesis increases", "Gas exchange is reduced", "Water absorption increases", "Growth becomes faster"],
    answer: "Gas exchange is reduced"
  },
  {
    question: "Why do we feel cooler when sweat evaporates from the skin?",
    options: ["It adds heat to the body", "It removes heat from the body", "It increases blood flow", "It reduces oxygen"],
    answer: "It removes heat from the body"
  },
  {
    question: "What is the likely effect of cutting down trees in large numbers?",
    options: ["Increase in rainfall", "Decrease in soil erosion", "Environmental imbalance", "Increase in oxygen only"],
    answer: "Environmental imbalance"
  },
  {
    question: "Why does a bulb not light in an open circuit?",
    options: ["Too much current", "Incomplete path for current flow", "Battery is strong", "Wire is too short"],
    answer: "Incomplete path for current flow"
  },
  {
    question: "What will happen if a person lacks iron in the diet?",
    options: ["Strong muscles", "Improved digestion", "Anaemia (low red blood cells)", "Faster breathing"],
    answer: "Anaemia (low red blood cells)"
  },
  {
    question: "Why do particles in gases spread out quickly?",
    options: ["They are tightly packed", "They have high kinetic energy", "They are fixed", "They are large"],
    answer: "They have high kinetic energy"
  },
  {
    question: "Which of the following best explains why metals expand when heated?",
    options: ["Particles move closer", "Particles gain energy and move apart", "Particles stop moving", "Particles shrink"],
    answer: "Particles gain energy and move apart"
  },
  {
    question: "What will happen if the alveoli in the lungs are damaged?",
    options: ["Digestion improves", "Gas exchange becomes inefficient", "Blood flow stops", "Heart rate decreases"],
    answer: "Gas exchange becomes inefficient"
  },
  {
    question: "Why is it dangerous to drink untreated water?",
    options: ["It contains too much oxygen", "It may contain harmful microorganisms", "It has no taste", "It increases temperature"],
    answer: "It may contain harmful microorganisms"
  },
  {
    question: "What is the effect of friction on moving objects?",
    options: ["It increases speed always", "It opposes motion", "It creates light", "It removes weight"],
    answer: "It opposes motion"
  },
  {
    question: "Why do we add manure or fertilizer to soil?",
    options: ["To reduce sunlight", "To increase soil nutrients", "To decrease water", "To reduce oxygen"],
    answer: "To increase soil nutrients"
  },
  {
    question: "What happens when a liquid changes into a gas at its surface?",
    options: ["Condensation", "Evaporation", "Freezing", "Melting"],
    answer: "Evaporation"
  },
  {
    question: "Which of the following best explains renewable resources?",
    options: ["Cannot be replaced", "Can be replaced naturally", "Used once only", "Very expensive"],
    answer: "Can be replaced naturally"
  },
  {
    question: "Why does light bend when it passes from air into water?",
    options: ["Reflection", "Refraction", "Diffusion", "Friction"],
    answer: "Refraction"
  },
  {
    question: "What is the likely effect of poor sanitation in a community?",
    options: ["Better health", "Spread of diseases", "Improved environment", "Increase in oxygen"],
    answer: "Spread of diseases"
  },
  {
    question: "Why do parallel circuits allow appliances to work independently?",
    options: ["Single path for current", "Multiple paths for current", "No current flow", "Increased resistance only"],
    answer: "Multiple paths for current"
  },
  {
    question: "What will happen if there is no gravity on Earth?",
    options: ["Objects fall faster", "Objects float freely", "Objects become heavier", "Objects stop existing"],
    answer: "Objects float freely"
  },
  {
    question: "Why is oxygen important in respiration?",
    options: ["It produces food", "It helps release energy from food", "It stores energy", "It controls movement"],
    answer: "It helps release energy from food"
  },
  {
    question: "What is the effect of adding too much waste to the environment?",
    options: ["Cleaner environment", "Reduced pollution", "Environmental pollution increases", "More oxygen is produced"],
    answer: "Environmental pollution increases"
  },
  {
    question: "Why do magnets lose strength when heated strongly?",
    options: ["Particles gain energy and disorder increases", "They become heavier", "They produce heat", "They shrink"],
    answer: "Particles gain energy and disorder increases"
  },
  {
    question: "A plant is exposed to sunlight but its leaves are coated with oil. What is the likely effect?",
    options: ["Photosynthesis increases", "Gas exchange is blocked", "Water absorption increases", "Growth becomes faster"],
    answer: "Gas exchange is blocked"
  },
  {
    question: "Why does a metal spoon feel hotter than a wooden spoon in hot water?",
    options: ["Metal produces heat", "Metal conducts heat faster", "Wood absorbs heat faster", "Wood is heavier"],
    answer: "Metal conducts heat faster"
  },
  {
    question: "What will happen if insulin is not produced in the body?",
    options: ["Digestion improves", "Blood sugar becomes uncontrolled", "Breathing slows", "Blood pressure drops"],
    answer: "Blood sugar becomes uncontrolled"
  },
  {
    question: "Why does increasing temperature increase the rate of dissolving substances?",
    options: ["Particles move slower", "Particles gain energy and collide more", "Water becomes solid", "Substances disappear"],
    answer: "Particles gain energy and collide more"
  },
  {
    question: "What is the likely effect of waterlogging in soil on plant roots?",
    options: ["Improved growth", "Lack of oxygen for roots", "Increased nutrients", "Faster photosynthesis"],
    answer: "Lack of oxygen for roots"
  },
  {
    question: "Why does sound not travel in space?",
    options: ["No light is present", "No medium for vibration", "Too much energy", "Too much heat"],
    answer: "No medium for vibration"
  },
  {
    question: "What happens when a current flows through a high resistance wire?",
    options: ["Current increases", "Heat is produced", "Voltage disappears", "Energy is lost completely"],
    answer: "Heat is produced"
  },
  {
    question: "Why do farmers rotate crops?",
    options: ["To reduce sunlight", "To maintain soil fertility", "To increase water loss", "To reduce oxygen"],
    answer: "To maintain soil fertility"
  },
  {
    question: "Which of the following explains why objects float?",
    options: ["They are heavy", "They are less dense than the liquid", "They absorb water", "They have no mass"],
    answer: "They are less dense than the liquid"
  },
  {
    question: "What will happen if the ozone layer is depleted?",
    options: ["Less sunlight reaches Earth", "More harmful radiation reaches Earth", "Air becomes cleaner", "Temperature decreases only"],
    answer: "More harmful radiation reaches Earth"
  },
  {
    question: "Why do particles in solids not move freely?",
    options: ["They have high energy", "They are tightly packed", "They are far apart", "They disappear"],
    answer: "They are tightly packed"
  },
  {
    question: "What is the effect of too much carbon dioxide in the atmosphere?",
    options: ["Cooling of Earth", "Global warming", "Increase in oxygen", "Decrease in sunlight"],
    answer: "Global warming"
  },
  {
    question: "Why is a fuse important in an electrical circuit?",
    options: ["To increase current", "To prevent damage from excess current", "To store energy", "To produce light"],
    answer: "To prevent damage from excess current"
  },
  {
    question: "What will happen if a person breathes in carbon monoxide?",
    options: ["Improved oxygen supply", "Reduced oxygen transport in blood", "Better breathing", "Increased energy"],
    answer: "Reduced oxygen transport in blood"
  },
  {
    question: "Why does cutting trees increase soil erosion?",
    options: ["Roots no longer hold soil", "Soil becomes stronger", "Water disappears", "Air pressure reduces"],
    answer: "Roots no longer hold soil"
  },
  {
    question: "What is the effect of increasing surface area of a substance in a reaction?",
    options: ["Reaction slows down", "Reaction rate increases", "No effect", "Reaction stops"],
    answer: "Reaction rate increases"
  },
  {
    question: "Why is the heart rate higher during exercise?",
    options: ["To cool the body", "To supply more oxygen to muscles", "To reduce blood flow", "To increase digestion"],
    answer: "To supply more oxygen to muscles"
  },
  {
    question: "What happens when light passes through a prism?",
    options: ["It disappears", "It splits into different colours", "It slows down completely", "It becomes sound"],
    answer: "It splits into different colours"
  },
  {
    question: "Why is proper waste disposal important in cities?",
    options: ["To increase pollution", "To prevent disease and environmental damage", "To reduce sunlight", "To increase heat"],
    answer: "To prevent disease and environmental damage"
  },
  {
    question: "A student places a plant in a sealed container exposed to sunlight. Why might the plant eventually die?",
    options: ["Too much oxygen", "Imbalance of gases over time", "Excess water", "Too much light"],
    answer: "Imbalance of gases over time"
  },
  {
    question: "Why do metals expand more quickly than most materials when heated?",
    options: ["They lose particles", "Their particles gain energy rapidly and spread apart", "They become lighter", "They absorb oxygen"],
    answer: "Their particles gain energy rapidly and spread apart"
  },
  {
    question: "What will happen if the kidneys fail to function properly?",
    options: ["Digestion improves", "Waste accumulates in the blood", "Oxygen supply increases", "Heart rate decreases"],
    answer: "Waste accumulates in the blood"
  },
  {
    question: "Why does a decrease in temperature slow down chemical reactions?",
    options: ["Particles stop moving", "Particles have less energy and collide less", "Substances disappear", "Energy increases"],
    answer: "Particles have less energy and collide less"
  },
  {
    question: "What is the effect of deforestation on the water cycle?",
    options: ["Increases rainfall always", "Reduces transpiration and rainfall", "Increases oxygen only", "Improves soil fertility"],
    answer: "Reduces transpiration and rainfall"
  },
  {
    question: "What will happen if there is too much resistance in a circuit?",
    options: ["Current increases", "Current decreases", "Voltage disappears", "Energy is created"],
    answer: "Current decreases"
  },
  {
    question: "Why is chlorophyll essential for plant survival?",
    options: ["It stores water", "It absorbs sunlight for photosynthesis", "It transports food", "It absorbs minerals"],
    answer: "It absorbs sunlight for photosynthesis"
  },
  {
    question: "What is the likely effect of overfishing in water bodies?",
    options: ["Increase in fish population", "Disruption of aquatic ecosystem", "More oxygen in water", "Improved water quality"],
    answer: "Disruption of aquatic ecosystem"
  },
  {
    question: "Why does increasing pressure on a gas reduce its volume?",
    options: ["Particles move slower", "Particles are forced closer together", "Gas disappears", "Temperature decreases"],
    answer: "Particles are forced closer together"
  },
  {
    question: "What happens when energy is transferred from one form to another?",
    options: ["Energy is destroyed", "Energy changes form but is conserved", "Energy disappears", "Energy reduces completely"],
    answer: "Energy changes form but is conserved"
  },
  {
    question: "Why does the body need vitamins in small amounts?",
    options: ["For energy only", "For proper body functioning and protection", "For movement only", "For digestion only"],
    answer: "For proper body functioning and protection"
  },
  {
    question: "What will happen if soil loses all its nutrients?",
    options: ["Plants grow faster", "Plants fail to grow properly", "Water increases", "Soil becomes stronger"],
    answer: "Plants fail to grow properly"
  },
  {
    question: "What is the effect of poor ventilation in a room?",
    options: ["Improved air quality", "Reduced oxygen and increased carbon dioxide", "Increase in light", "Decrease in temperature"],
    answer: "Reduced oxygen and increased carbon dioxide"
  },
  {
    question: "Why is it important to conserve water resources?",
    options: ["To waste water", "To ensure future availability", "To increase pollution", "To reduce sunlight"],
    answer: "To ensure future availability"
  },
  {
    question: "What will happen if enzymes in the body stop working?",
    options: ["Digestion slows or stops", "Energy increases", "Blood flow increases", "Breathing improves"],
    answer: "Digestion slows or stops"
  },
  {
    question: "Why do parallel circuits continue working when one appliance fails?",
    options: ["Single path exists", "Multiple independent paths exist", "No current flows", "Resistance disappears"],
    answer: "Multiple independent paths exist"
  },
  {
    question: "What is the effect of increased greenhouse gases in the atmosphere?",
    options: ["Cooling of Earth", "Global warming", "Decrease in sunlight", "Improved rainfall only"],
    answer: "Global warming"
  },
  {
    question: "Why is friction useful in daily life?",
    options: ["It stops all motion", "It helps in movement and prevents slipping", "It removes energy", "It reduces weight"],
    answer: "It helps in movement and prevents slipping"
  },
  {
    question: "A plant is placed under green light only. What is the likely effect on photosynthesis?",
    options: ["Photosynthesis increases", "Photosynthesis decreases significantly", "No effect", "Photosynthesis stops completely"],
    answer: "Photosynthesis decreases significantly"
  },
  {
    question: "Why do athletes breathe more deeply during exercise?",
    options: ["To remove nitrogen", "To supply more oxygen and remove carbon dioxide", "To reduce blood pressure", "To cool the lungs"],
    answer: "To supply more oxygen and remove carbon dioxide"
  },
  {
    question: "Which method can be used to separate alcohol from water?",
    options: ["Filtration", "Distillation", "Sieving", "Decanting"],
    answer: "Distillation"
  },
  {
    question: "What is the main reason why bridges are built with expansion joints?",
    options: ["To reduce weight", "To allow expansion due to heat", "To increase strength only", "To reduce cost"],
    answer: "To allow expansion due to heat"
  },
  {
    question: "Which blood component is responsible for clotting?",
    options: ["Red blood cells", "White blood cells", "Platelets", "Plasma"],
    answer: "Platelets"
  },
  {
    question: "Why does increasing pressure increase the boiling point of a liquid?",
    options: ["Particles gain energy faster", "More energy is needed for particles to escape", "Liquid becomes solid", "Particles stop moving"],
    answer: "More energy is needed for particles to escape"
  },
  {
    question: "What is the function of the medulla in the brain?",
    options: ["Controls voluntary actions", "Controls involuntary activities like breathing", "Stores memory", "Controls vision"],
    answer: "Controls involuntary activities like breathing"
  },
  {
    question: "Why are dark-colored clothes hotter in sunlight?",
    options: ["They reflect more light", "They absorb more heat", "They produce heat", "They reduce sunlight"],
    answer: "They absorb more heat"
  },
  {
    question: "What happens when a catalyst is added to a chemical reaction?",
    options: ["Reaction stops", "Reaction slows down", "Reaction speeds up", "Energy is destroyed"],
    answer: "Reaction speeds up"
  },
  {
    question: "Which organ is responsible for removing carbon dioxide from the body?",
    options: ["Kidney", "Liver", "Lungs", "Heart"],
    answer: "Lungs"
  },
  {
    question: "Why does a sharp knife cut better than a blunt one?",
    options: ["It has more weight", "It exerts greater pressure on a smaller area", "It moves faster", "It has less friction"],
    answer: "It exerts greater pressure on a smaller area"
  },
  {
    question: "What is the effect of acid rain on buildings?",
    options: ["Strengthens structures", "Causes corrosion and damage", "Improves appearance", "Reduces temperature"],
    answer: "Causes corrosion and damage"
  },
  {
    question: "Which process is responsible for the movement of water through a plant?",
    options: ["Diffusion", "Transpiration pull", "Respiration", "Photosynthesis"],
    answer: "Transpiration pull"
  },
  {
    question: "Why does a person feel dizzy at high altitudes?",
    options: ["More oxygen is available", "Less oxygen is available", "Temperature is high", "Air pressure is high"],
    answer: "Less oxygen is available"
  },
  {
    question: "What type of energy transformation occurs in a solar panel?",
    options: ["Electrical to chemical", "Light to electrical", "Heat to sound", "Chemical to light"],
    answer: "Light to electrical"
  },
  {
    question: "Why is it difficult to compress a liquid?",
    options: ["Particles are far apart", "Particles are closely packed", "Particles have no energy", "Particles are large"],
    answer: "Particles are closely packed"
  },
  {
    question: "Which of the following is an effect of overpopulation?",
    options: ["More resources", "Less pollution", "Pressure on natural resources", "Better environment"],
    answer: "Pressure on natural resources"
  },
  {
    question: "Why does an object sink in water?",
    options: ["It is less dense than water", "It is more dense than water", "It absorbs water", "It contains air"],
    answer: "It is more dense than water"
  },
  {
    question: "What happens to enzymes at very high temperatures?",
    options: ["They work faster", "They are destroyed (denatured)", "They increase in number", "They stop existing"],
    answer: "They are destroyed (denatured)"
  },
  {
    question: "Why is conservation of forests important?",
    options: ["To increase pollution", "To maintain ecological balance", "To reduce rainfall", "To remove oxygen"],
    answer: "To maintain ecological balance"
  },
  {
    question: "Why do plants appear green in colour?",
    options: ["They absorb green light", "They reflect green light", "They produce green pigment only", "They absorb all colours equally"],
    answer: "They reflect green light"
  },
  {
    question: "What happens to the volume of a gas when its temperature increases (at constant pressure)?",
    options: ["Decreases", "Remains constant", "Increases", "Becomes zero"],
    answer: "Increases"
  },
  {
    question: "Which of the following prevents backflow of blood in the heart?",
    options: ["Arteries", "Veins", "Valves", "Capillaries"],
    answer: "Valves"
  },
  {
    question: "Why does salt preserve food?",
    options: ["It adds nutrients", "It removes water from microorganisms", "It increases temperature", "It adds oxygen"],
    answer: "It removes water from microorganisms"
  },
  {
    question: "Which form of energy is stored in a stretched rubber band?",
    options: ["Kinetic energy", "Chemical energy", "Elastic potential energy", "Heat energy"],
    answer: "Elastic potential energy"
  },
  {
    question: "Why do objects appear larger when viewed through a magnifying glass?",
    options: ["Reflection of light", "Refraction of light", "Absorption of light", "Diffusion of light"],
    answer: "Refraction of light"
  },
  {
    question: "What is the function of the large intestine in digestion?",
    options: ["Digests proteins", "Absorbs water from undigested food", "Produces enzymes", "Stores oxygen"],
    answer: "Absorbs water from undigested food"
  },
  {
    question: "Which factor increases the rate of evaporation?",
    options: ["Low temperature", "High humidity", "High temperature", "Low surface area"],
    answer: "High temperature"
  },
  {
    question: "Why does iron rust faster in salty water?",
    options: ["Salt reduces oxygen", "Salt acts as a catalyst", "Salt increases conductivity of water", "Salt removes water"],
    answer: "Salt increases conductivity of water"
  },
  {
    question: "Which of the following is an example of a vector quantity?",
    options: ["Speed", "Distance", "Velocity", "Time"],
    answer: "Velocity"
  },
  {
    question: "Why is the skin considered an excretory organ?",
    options: ["It produces blood", "It removes sweat containing waste", "It stores nutrients", "It controls movement"],
    answer: "It removes sweat containing waste"
  },
  {
    question: "What is the main purpose of vaccination?",
    options: ["To cure diseases", "To prevent diseases by building immunity", "To increase appetite", "To reduce temperature"],
    answer: "To prevent diseases by building immunity"
  },
  {
    question: "Which process converts liquid water into water vapour below boiling point?",
    options: ["Condensation", "Evaporation", "Freezing", "Melting"],
    answer: "Evaporation"
  },
  {
    question: "Why does a metal rod feel hot at one end when the other end is heated?",
    options: ["Convection", "Radiation", "Conduction", "Reflection"],
    answer: "Conduction"
  },
  {
    question: "What is the function of the pancreas in digestion?",
    options: ["Produces bile", "Produces digestive enzymes", "Stores food", "Pumps blood"],
    answer: "Produces digestive enzymes"
  },
  {
    question: "Which of the following is a greenhouse gas?",
    options: ["Oxygen", "Nitrogen", "Carbon dioxide", "Hydrogen"],
    answer: "Carbon dioxide"
  },
  {
    question: "Why does increasing surface area increase the rate of a reaction?",
    options: ["Less collision", "More particle collisions", "Less energy", "No change"],
    answer: "More particle collisions"
  },
  {
    question: "What happens when a substance gains electrons?",
    options: ["It becomes positive", "It becomes negative", "It becomes neutral", "It disappears"],
    answer: "It becomes negative"
  },
  {
    question: "Why do we wear light-coloured clothes in hot weather?",
    options: ["They absorb more heat", "They reflect more heat", "They produce cold", "They increase temperature"],
    answer: "They reflect more heat"
  },
  {
    question: "What is the main effect of deforestation on wildlife?",
    options: ["Increase in habitat", "Loss of habitat", "Increase in food supply", "Improved environment"],
    answer: "Loss of habitat"
  },
  {
    question: "Why does a person shiver in cold weather?",
    options: ["To lose heat", "To generate heat through muscle activity", "To reduce blood flow", "To increase oxygen"],
    answer: "To generate heat through muscle activity"
  },
  {
    question: "Which of the following best explains diffusion?",
    options: ["Movement from low to high concentration", "Movement from high to low concentration", "Movement of solids only", "Movement caused by gravity"],
    answer: "Movement from high to low concentration"
  },
  {
    question: "Why is a vacuum flask able to keep liquids hot for a long time?",
    options: ["It produces heat", "It reduces heat transfer", "It increases temperature", "It absorbs cold"],
    answer: "It reduces heat transfer"
  },
  {
    question: "What happens when light passes from water into air?",
    options: ["It stops", "It bends away from the normal", "It disappears", "It becomes sound"],
    answer: "It bends away from the normal"
  },
  {
    question: "Which part of the brain controls balance and coordination?",
    options: ["Cerebrum", "Cerebellum", "Medulla", "Spinal cord"],
    answer: "Cerebellum"
  },
  {
    question: "Why do farmers irrigate crops?",
    options: ["To reduce sunlight", "To supply water when rainfall is low", "To increase soil erosion", "To reduce nutrients"],
    answer: "To supply water when rainfall is low"
  },
  {
    question: "What is the effect of adding more solute to a saturated solution?",
    options: ["It dissolves completely", "It settles at the bottom", "It disappears", "It turns to gas"],
    answer: "It settles at the bottom"
  },
  {
    question: "Which of the following best explains inertia?",
    options: ["Ability to change motion", "Resistance to change in motion", "Force that pulls objects", "Energy of movement"],
    answer: "Resistance to change in motion"
  },
  {
    question: "Why does breathing rate increase when carbon dioxide levels rise?",
    options: ["To reduce oxygen", "To remove excess carbon dioxide", "To increase nitrogen", "To reduce heat"],
    answer: "To remove excess carbon dioxide"
  },
  {
    question: "What type of lens is used to correct short-sightedness?",
    options: ["Convex lens", "Concave lens", "Plane mirror", "Prism"],
    answer: "Concave lens"
  },
  {
    question: "Why is fermentation important in food production?",
    options: ["It increases oxygen", "It helps produce substances like alcohol and bread", "It removes nutrients", "It reduces temperature"],
    answer: "It helps produce substances like alcohol and bread"
  },
  {
    question: "What happens to pressure when force is applied over a smaller area?",
    options: ["Pressure decreases", "Pressure increases", "Pressure remains constant", "Pressure disappears"],
    answer: "Pressure increases"
  },
  {
    question: "Why do we feel less weight in water?",
    options: ["Water reduces gravity", "Upthrust opposes weight", "Mass decreases", "Density decreases"],
    answer: "Upthrust opposes weight"
  },
  {
    question: "Which process releases energy in living cells?",
    options: ["Photosynthesis", "Respiration", "Transpiration", "Diffusion"],
    answer: "Respiration"
  },
  {
    question: "Why does a candle go off when covered with a jar?",
    options: ["Too much oxygen", "Oxygen is used up", "Temperature increases", "Wax disappears"],
    answer: "Oxygen is used up"
  },
  {
    question: "What is the function of the rib cage?",
    options: ["Produce blood", "Protect vital organs like lungs and heart", "Control movement", "Digest food"],
    answer: "Protect vital organs like lungs and heart"
  },
  {
    question: "Why is composting beneficial?",
    options: ["Increases pollution", "Produces organic fertilizer", "Reduces oxygen", "Increases waste"],
    answer: "Produces organic fertilizer"
  },
  {
    question: "What happens when two different substances react chemically?",
    options: ["They remain unchanged", "New substances are formed", "They separate", "They disappear"],
    answer: "New substances are formed"
  },
  {
    question: "Why does increasing temperature increase kinetic energy?",
    options: ["Particles stop moving", "Particles move faster", "Particles shrink", "Particles disappear"],
    answer: "Particles move faster"
  },
  {
    question: "Which of the following best explains renewable energy sources?",
    options: ["They cannot be replaced", "They are exhausted quickly", "They are naturally replenished", "They produce pollution only"],
    answer: "They are naturally replenished"
  },
  {
    question: "Why does a steel bridge have gaps between sections?",
    options: ["To reduce weight", "To allow for thermal expansion", "To increase strength", "To reduce cost"],
    answer: "To allow for thermal expansion"
  },
  {
    question: "What happens to the density of a substance when its volume increases but mass remains constant?",
    options: ["Density increases", "Density decreases", "Density remains the same", "Density becomes zero"],
    answer: "Density decreases"
  },
  {
    question: "Which part of the human body produces insulin?",
    options: ["Liver", "Pancreas", "Kidney", "Stomach"],
    answer: "Pancreas"
  },
  {
    question: "Why does an object continue moving when no external force acts on it?",
    options: ["Due to friction", "Due to inertia", "Due to gravity", "Due to pressure"],
    answer: "Due to inertia"
  },
  {
    question: "What is the function of chloroplast in plant cells?",
    options: ["Store water", "Carry out photosynthesis", "Transport nutrients", "Produce oxygen only"],
    answer: "Carry out photosynthesis"
  },
  {
    question: "Why do we experience seasons on Earth?",
    options: ["Distance from the Sun changes", "Tilt of the Earth's axis", "Sun's temperature changes", "Cloud movement"],
    answer: "Tilt of the Earth's axis"
  },
  {
    question: "Which process is responsible for cooling when a liquid evaporates?",
    options: ["Condensation", "Evaporation", "Freezing", "Melting"],
    answer: "Evaporation"
  },
  {
    question: "What happens when a force acts on a stationary object?",
    options: ["It remains at rest", "It starts moving", "It disappears", "It becomes lighter"],
    answer: "It starts moving"
  },
  {
    question: "Why are veins thinner than arteries?",
    options: ["They carry more blood", "They carry blood at lower pressure", "They produce blood", "They contain oxygen only"],
    answer: "They carry blood at lower pressure"
  },
  {
    question: "What is the effect of increasing voltage in a circuit?",
    options: ["Current decreases", "Current increases", "Resistance increases", "Energy disappears"],
    answer: "Current increases"
  },
  {
    question: "Why do we feel heat from the Sun even though space is a vacuum?",
    options: ["Conduction", "Convection", "Radiation", "Diffusion"],
    answer: "Radiation"
  },
  {
    question: "Which of the following is a biodegradable material?",
    options: ["Plastic", "Glass", "Paper", "Metal"],
    answer: "Paper"
  },
  {
    question: "Why does a heavier object not always fall faster than a lighter one?",
    options: ["Due to air resistance", "Due to gravity", "Due to density", "Due to pressure"],
    answer: "Due to air resistance"
  },
  {
    question: "What is the main function of white blood cells?",
    options: ["Carry oxygen", "Fight infections", "Clot blood", "Store nutrients"],
    answer: "Fight infections"
  },
  {
    question: "Why is it easier to dissolve sugar in hot tea than in cold water?",
    options: ["Particles are larger", "Particles move faster at higher temperature", "Water is heavier", "Sugar changes state"],
    answer: "Particles move faster at higher temperature"
  },
  {
    question: "What happens when a magnet is heated strongly?",
    options: ["It becomes stronger", "It loses its magnetism", "It increases weight", "It produces electricity"],
    answer: "It loses its magnetism"
  },
  {
    question: "Why is the atmosphere important to life on Earth?",
    options: ["It produces soil", "It provides gases and protection", "It reduces gravity", "It produces water"],
    answer: "It provides gases and protection"
  },
  {
    question: "What is the effect of too much fertilizer entering water bodies?",
    options: ["Improves water quality", "Causes water pollution and algal growth", "Increases oxygen", "Reduces temperature"],
    answer: "Causes water pollution and algal growth"
  },
  {
    question: "Which of the following best explains pressure?",
    options: ["Force only", "Force per unit area", "Energy per unit time", "Mass per volume"],
    answer: "Force per unit area"
  },
  {
    question: "Why does a concave mirror form a magnified image when an object is close?",
    options: ["Reflection of light rays", "Refraction of light", "Absorption of light", "Diffusion of light"],
    answer: "Reflection of light rays"
  },
  
{
  question: "The diagram shows a filtration setup. What is collected as the filtrate?",
  image: "/images/filtration1.png",
  options: [
    "Solid on the filter paper",
    "Liquid that passes through",
    "Mixture before filtration",
    "Residue in the funnel"
  ],
  answer: "Liquid that passes through"
},

{
  question: "The diagram shows a simple electric circuit. What happens when the switch is closed?",
  image: "/images/circuit1.png",
  options: [
    "No current flows",
    "Bulb lights",
    "Battery stops working",
    "Wire breaks"
  ],
  answer: "Bulb lights"
},

{
  question: "The diagram shows the human heart. Which chamber pumps blood to the body?",
  image: "/images/heart1.png",
  options: [
    "Right atrium",
    "Left atrium",
    "Right ventricle",
    "Left ventricle"
  ],
  answer: "Left ventricle"
},

{
  question: "The diagram shows lungs. What process is taking place?",
  image: "/images/lungs1.png",
  options: [
    "Digestion",
    "Respiration",
    "Excretion",
    "Circulation"
  ],
  answer: "Respiration"
},

{
  question: "The diagram shows a thermometer reading. What is the temperature shown?",
  image: "/images/thermometer1.png",
  options: ["20°C", "25°C", "30°C", "35°C"],
  answer: "25°C"
},

{
  question: "The diagram shows a magnet attracting objects. Which material is attracted?",
  image: "/images/magnet1.png",
  options: [
    "Plastic",
    "Wood",
    "Iron nail",
    "Rubber"
  ],
  answer: "Iron nail"
},

{
  question: "The diagram shows a food chain. Which organism is the secondary consumer?",
  image: "/images/foodchain1.png",
  options: [
    "Grass",
    "Grasshopper",
    "Frog",
    "Snake"
  ],
  answer: "Frog"
},

{
  question: "The diagram shows evaporation of water. What causes this process?",
  image: "/images/evaporation1.png",
  options: [
    "Cooling",
    "Heating",
    "Freezing",
    "Condensation"
  ],
  answer: "Heating"
},

{
  question: "The diagram shows a lever. What is the function of the fulcrum?",
  image: "/images/lever1.png",
  options: [
    "Applies force",
    "Holds the load",
    "Acts as pivot point",
    "Reduces weight"
  ],
  answer: "Acts as pivot point"
},

{
  question: "The diagram shows a plant cell. Which part contains chlorophyll?",
  image: "/images/plantcell1.png",
  options: [
    "Nucleus",
    "Vacuole",
    "Chloroplast",
    "Cell membrane"
  ],
  answer: "Chloroplast"
},

{
  question: "The diagram shows the human digestive system. Where does digestion begin?",
  image: "/images/digestive1.png",
  options: [
    "Stomach",
    "Mouth",
    "Small intestine",
    "Large intestine"
  ],
  answer: "Mouth"
},

{
  question: "The diagram shows the eye. Which part focuses light?",
  image: "/images/eye1.png",
  options: [
    "Retina",
    "Iris",
    "Lens",
    "Optic nerve"
  ],
  answer: "Lens"
},

{
  question: "The diagram shows a pulley system. What is its main advantage?",
  image: "/images/pulley1.png",
  options: [
    "Increases friction",
    "Changes direction of force",
    "Stores energy",
    "Produces heat"
  ],
  answer: "Changes direction of force"
},

{
  question: "The diagram shows a seed germinating. Which part emerges first?",
  image: "/images/germination1.png",
  options: [
    "Leaf",
    "Stem",
    "Root",
    "Flower"
  ],
  answer: "Root"
},

{
  question: "The diagram shows the human skeleton. Which part protects the heart and lungs?",
  image: "/images/skeleton1.png",
  options: [
    "Skull",
    "Rib cage",
    "Spine",
    "Pelvis"
  ],
  answer: "Rib cage"
},

{
  question: "The diagram shows a water cycle. What process forms clouds?",
  image: "/images/watercycle1.png",
  options: [
    "Evaporation",
    "Condensation",
    "Precipitation",
    "Collection"
  ],
  answer: "Condensation"
},

{
  question: "The diagram shows a balance. What is being measured?",
  image: "/images/balance1.png",
  options: [
    "Force",
    "Weight",
    "Mass",
    "Pressure"
  ],
  answer: "Mass"
},

{
  question: "The diagram shows a circuit with two bulbs in series. What happens if one bulb is removed?",
  image: "/images/circuit2.png",
  options: [
    "Other bulb stays on",
    "All bulbs go off",
    "Battery increases power",
    "Nothing changes"
  ],
  answer: "All bulbs go off"
},

{
  question: "The diagram shows a leaf. What process occurs in the leaf?",
  image: "/images/leaf1.png",
  options: [
    "Respiration",
    "Photosynthesis",
    "Transpiration",
    "All of the above"
  ],
  answer: "All of the above"
},

{
  question: "The diagram shows the ear. Which part is responsible for hearing?",
  image: "/images/ear1.png",
  options: [
    "Eardrum",
    "Cochlea",
    "Nerve",
    "Canal"
  ],
  answer: "Cochlea"
},

{
  question: "The diagram shows a pH scale. Which substance is strongly acidic?",
  image: "/images/phscale1.png",
  options: ["pH 2", "pH 7", "pH 9", "pH 12"],
  answer: "pH 2"
},

{
  question: "The diagram shows acid-base indicators. Which colour shows a base in litmus test?",
  image: "/images/indicator1.png",
  options: ["Red", "Blue", "Green", "Yellow"],
  answer: "Blue"
},

{
  question: "The diagram shows particles in a solid, liquid, and gas. Which has the highest kinetic energy?",
  image: "/images/states1.png",
  options: ["Solid", "Liquid", "Gas", "All equal"],
  answer: "Gas"
},

{
  question: "The diagram shows atomic structure. What is the charge of electrons?",
  image: "/images/atom1.png",
  options: ["Positive", "Negative", "Neutral", "Mixed"],
  answer: "Negative"
},

{
  question: "The diagram shows a mixture being separated by distillation. What is collected first?",
  image: "/images/distillation1.png",
  options: ["Substance with higher boiling point", "Substance with lower boiling point", "Residue", "Solid"],
  answer: "Substance with lower boiling point"
},

{
  question: "The diagram shows bonding between atoms. What type of bond is shown?",
  image: "/images/bonding1.png",
  options: ["Ionic", "Covalent", "Metallic", "Hydrogen"],
  answer: "Covalent"
},

{
  question: "The diagram shows the life cycle of a mosquito. Which stage causes disease transmission?",
  image: "/images/mosquito1.png",
  options: ["Egg", "Larva", "Pupa", "Adult"],
  answer: "Adult"
},

{
  question: "The diagram shows a carbon cycle. What process removes carbon dioxide from the atmosphere?",
  image: "/images/carboncycle1.png",
  options: ["Respiration", "Photosynthesis", "Combustion", "Decay"],
  answer: "Photosynthesis"
},

{
  question: "The diagram shows types of teeth. Which is used for tearing food?",
  image: "/images/teeth1.png",
  options: ["Incisor", "Canine", "Premolar", "Molar"],
  answer: "Canine"
},

{
  question: "The diagram shows the digestive system. Where is bile produced?",
  image: "/images/digestive3.png",
  options: ["Stomach", "Liver", "Pancreas", "Intestine"],
  answer: "Liver"
},

{
  question: "The diagram shows the heart. Which vessel carries oxygenated blood?",
  image: "/images/heart2.png",
  options: ["Pulmonary artery", "Pulmonary vein", "Vena cava", "Aorta"],
  answer: "Aorta"
},

{
  question: "The diagram shows respiration. What happens in the alveoli?",
  image: "/images/alveoli1.png",
  options: ["Digestion", "Gas exchange", "Filtration", "Absorption"],
  answer: "Gas exchange"
},

{
  question: "The diagram shows a food web. Which organism is both a predator and prey?",
  image: "/images/foodweb1.png",
  options: ["Grass", "Grasshopper", "Frog", "Snake"],
  answer: "Frog"
},

{
  question: "The diagram shows waste disposal methods. Which is most environmentally friendly?",
  image: "/images/waste1.png",
  options: ["Burning", "Dumping", "Recycling", "Burying"],
  answer: "Recycling"
},

{
  question: "The diagram shows greenhouse effect. What gas contributes most?",
  image: "/images/greenhouse1.png",
  options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
  answer: "Carbon dioxide"
},

{
  question: "The diagram shows reflection of light. What law is demonstrated?",
  image: "/images/reflection1.png",
  options: [
    "Angle of incidence equals angle of reflection",
    "Light travels in straight line",
    "Refraction law",
    "Dispersion law"
  ],
  answer: "Angle of incidence equals angle of reflection"
},

{
  question: "The diagram shows refraction. Why does light bend?",
  image: "/images/refraction1.png",
  options: [
    "Change in speed",
    "Change in direction only",
    "Increase in energy",
    "Loss of light"
  ],
  answer: "Change in speed"
},

{
  question: "The diagram shows a simple machine. What determines efficiency?",
  image: "/images/machine1.png",
  options: [
    "Input only",
    "Output only",
    "Output/Input",
    "Force only"
  ],
  answer: "Output/Input"
},

{
  question: "The diagram shows planets in orbit. Which is closest to the Sun?",
  image: "/images/solarsystem1.png",
  options: ["Earth", "Mars", "Mercury", "Venus"],
  answer: "Mercury"
},

{
  question: "The diagram shows soil profile. Which layer is richest in humus?",
  image: "/images/soil1.png",
  options: ["Topsoil", "Subsoil", "Bedrock", "Parent rock"],
  answer: "Topsoil"
},

{
  question: "The diagram shows a neutralization reaction setup. What is formed after reaction?",
  image: "/images/neutralization1.png",
  options: ["Salt and water", "Acid only", "Base only", "Gas only"],
  answer: "Salt and water"
},

{
  question: "The diagram shows a suspension. Why do particles settle?",
  image: "/images/suspension1.png",
  options: [
    "They are lighter",
    "They are insoluble and heavy",
    "They dissolve",
    "They evaporate"
  ],
  answer: "They are insoluble and heavy"
},

{
  question: "The diagram shows electron arrangement. What determines the atomic number?",
  image: "/images/electron1.png",
  options: ["Neutrons", "Protons", "Electrons", "Mass"],
  answer: "Protons"
},

{
  question: "The diagram shows ionic bonding. What happens to electrons?",
  image: "/images/ionic1.png",
  options: [
    "Shared",
    "Transferred",
    "Destroyed",
    "Multiplied"
  ],
  answer: "Transferred"
},

{
  question: "The diagram shows a prokaryotic cell. What is missing?",
  image: "/images/prokaryote1.png",
  options: ["Cell wall", "Nucleus", "Cytoplasm", "Membrane"],
  answer: "Nucleus"
},

{
  question: "The diagram shows a eukaryotic cell. What makes it different?",
  image: "/images/eukaryote1.png",
  options: [
    "No cytoplasm",
    "Has nucleus",
    "No membrane",
    "No organelles"
  ],
  answer: "Has nucleus"
},

{
  question: "The diagram shows the life cycle of a grasshopper. Why is it incomplete metamorphosis?",
  image: "/images/grasshopper1.png",
  options: [
    "No pupa stage",
    "No egg stage",
    "No adult",
    "No larva"
  ],
  answer: "No pupa stage"
},

{
  question: "The diagram shows the respiratory system. What is the function of the diaphragm?",
  image: "/images/diaphragm1.png",
  options: [
    "Pump blood",
    "Control breathing",
    "Digest food",
    "Filter air"
  ],
  answer: "Control breathing"
},

{
  question: "The diagram shows blood circulation. Which vessel carries blood to the heart?",
  image: "/images/vein1.png",
  options: ["Artery", "Vein", "Capillary", "Aorta"],
  answer: "Vein"
},

{
  question: "The diagram shows a habitat. Which factor is abiotic?",
  image: "/images/habitat1.png",
  options: ["Plants", "Animals", "Water", "Bacteria"],
  answer: "Water"
},

{
  question: "The diagram shows communicable disease spread. How is it transmitted?",
  image: "/images/disease1.png",
  options: [
    "Inheritance",
    "Contact",
    "Growth",
    "Digestion"
  ],
  answer: "Contact"
},

{
  question: "The diagram shows recycling process. What is the benefit?",
  image: "/images/recycle1.png",
  options: [
    "Increase waste",
    "Reduce pollution",
    "Destroy materials",
    "Increase cost"
  ],
  answer: "Reduce pollution"
},

{
  question: "The diagram shows climate change. What is the main cause?",
  image: "/images/climate1.png",
  options: [
    "Plant growth",
    "Greenhouse gases",
    "Water cycle",
    "Wind"
  ],
  answer: "Greenhouse gases"
},

{
  question: "The diagram shows heat transfer. What type is shown?",
  image: "/images/conduction1.png",
  options: ["Conduction", "Convection", "Radiation", "Evaporation"],
  answer: "Conduction"
},

{
  question: "The diagram shows light dispersion. What is formed?",
  image: "/images/dispersion1.png",
  options: ["Shadow", "Rainbow", "Image", "Reflection"],
  answer: "Rainbow"
},

{
  question: "The diagram shows a shadow. Why is shadow formed?",
  image: "/images/shadow1.png",
  options: [
    "Light bends",
    "Light travels in curves",
    "Light travels in straight lines",
    "Light disappears"
  ],
  answer: "Light travels in straight lines"
},

{
  question: "The diagram shows a magnet being made. What method is used?",
  image: "/images/magnetmaking1.png",
  options: [
    "Heating",
    "Stroking",
    "Cooling",
    "Breaking"
  ],
  answer: "Stroking"
},

{
  question: "The diagram shows pressure applied. What happens when area decreases?",
  image: "/images/pressure1.png",
  options: [
    "Pressure decreases",
    "Pressure increases",
    "No change",
    "Stops"
  ],
  answer: "Pressure increases"
},

{
  question: "The diagram shows crop rotation. What is its benefit?",
  image: "/images/croprotation1.png",
  options: [
    "Soil depletion",
    "Soil fertility",
    "Increase pests",
    "Reduce growth"
  ],
  answer: "Soil fertility"
},

{
  question: "The diagram shows farm tools. Which is used for digging?",
  image: "/images/tools1.png",
  options: ["Cutlass", "Hoe", "Watering can", "Rake"],
  answer: "Hoe"
},

{
  question: "The diagram shows a solution with solute and solvent. What is the solvent?",
  image: "/images/solution1.png",
  options: [
    "Substance dissolved",
    "Liquid that dissolves the solute",
    "Solid particles",
    "Gas above the solution"
  ],
  answer: "Liquid that dissolves the solute"
},

{
  question: "The diagram shows electrolysis setup. What moves towards the cathode?",
  image: "/images/electrolysis1.png",
  options: [
    "Anions",
    "Cations",
    "Neutrons",
    "Atoms"
  ],
  answer: "Cations"
},

{
  question: "The diagram shows an animal cell. Which part controls activities?",
  image: "/images/animalcell1.png",
  options: [
    "Cytoplasm",
    "Cell membrane",
    "Nucleus",
    "Vacuole"
  ],
  answer: "Nucleus"
},

{
  question: "The diagram shows a neuron. What is its function?",
  image: "/images/neuron1.png",
  options: [
    "Transport oxygen",
    "Transmit impulses",
    "Digest food",
    "Filter blood"
  ],
  answer: "Transmit impulses"
},

{
  question: "The diagram shows the kidney. What is its function?",
  image: "/images/kidney1.png",
  options: [
    "Pump blood",
    "Filter waste from blood",
    "Digest food",
    "Control breathing"
  ],
  answer: "Filter waste from blood"
},

{
  question: "The diagram shows a food test. What nutrient is tested using iodine?",
  image: "/images/iodinetest1.png",
  options: [
    "Protein",
    "Fat",
    "Starch",
    "Vitamin"
  ],
  answer: "Starch"
},

{
  question: "The diagram shows convection currents. Where does hot fluid move?",
  image: "/images/convection1.png",
  options: [
    "Downward",
    "Sideways",
    "Upward",
    "Nowhere"
  ],
  answer: "Upward"
},

{
  question: "The diagram shows an eclipse. What type is shown?",
  image: "/images/eclipse1.png",
  options: [
    "Solar eclipse",
    "Lunar eclipse",
    "Partial eclipse",
    "Total eclipse"
  ],
  answer: "Solar eclipse"
},

{
  question: "The diagram shows irrigation. What is its purpose?",
  image: "/images/irrigation1.png",
  options: [
    "Remove crops",
    "Supply water to crops",
    "Add fertilizer",
    "Harvest crops"
  ],
  answer: "Supply water to crops"
},

{
  question: "The diagram shows soil erosion. What is the main cause?",
  image: "/images/erosion1.png",
  options: [
    "Plant growth",
    "Wind or water",
    "Sunlight",
    "Animals"
  ],
  answer: "Wind or water"
},

{
  question: "Which state of matter has no fixed volume or shape?",
  options: ["Solid", "Liquid", "Gas", "Plasma"],
  answer: "Gas"
}
];
export default jhscoreScienceQuestions;